import React, { Component } from "react";
import ModalHead from "./../components/modal-head/modalHead";
import * as handler from "../components/utils/handler";
import PrimaryButton from "./../components/utils/primaryButton";
import { DataService } from "./../services/data.service";
import swal from "sweetalert";
import BookingSummary from "../components/booking-summary/Booking-Summary";
import DangerButton from "../components/utils/dangerButton";
import Loader from "./../components/loader/loader";
import $ from "jquery";
import _ from "underscore";

const queryString = require("query-string");

let appointmentNumber = queryString.parse(
  window.location.search
).appointmentnumber;

let { redirectToCurrentPage, appRoute } =
  window["app-config"].applicationProperties;
class ModifyAppointment extends Component {
  UI = window["app-config"].ui.modifyAppointmentScreen;
  userDetailsConfig = window["app-config"].userDetails;
  defaultTheme = window["app-config"].defaultTheme;
  app = window["app-config"].runApp;

  state = {
    lang: {},
    enableSubmitBtn: false,
    isInfoDataLoaded: false,
    dataLoaded: true,
    response: null,
    appointmentNumber: null,
    phoneNumber: null,
    redirectUrl: "",

    email: null,
    isValidEmail: false,
    isValidAppointmentNumber: false,
    isValidPhoneNumber: false,
  };

  dataService = new DataService();

  componentDidMount() {
    this.setState({
      lang: handler.setTranslations(),
    });
    if (appointmentNumber !== undefined && appointmentNumber !== "") {
      this.getAppointmentInfo(appointmentNumber);
    }
  }

  getAppointmentInfo = async (appointmentNumber) => {
    this.setState({ dataLoaded: false });
    try {
      let response = await this.dataService.getAppointmentInfo(
        appointmentNumber,
        this.state.email,
        this.state.phoneNumber
      );
      if (response.data.error !== undefined && response.data.error === true) {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.ServerNotResponding,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
        this.setState({ isInfoDataLoaded: false, dataLoaded: true });
      } else if (
        response.data.response_code === 100 &&
        response.data.message.toLowerCase() === "success"
      ) {
        this.setState({
          response: response.data.appointment_info,
          redirectUrl: handler.removeKeyFromUrl(
            [redirectToCurrentPage ? "modifyappointment" : appRoute],
            "appointmentnumber",
            [
              this.app === "samsung" && redirectToCurrentPage === false
                ? `&branchCode=${response.data.appointment_info.branch_code}`
                : "",
            ]
          ),
          isInfoDataLoaded: true,
          dataLoaded: true,
        });
      } else if (
        response.data.response_code === 102 &&
        response.data.message.toLowerCase() === "no appointment found."
      ) {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.AppointmentNotFound,
          this.state.lang.Ok,
          this.state.redirectUrl
        );

        this.setState({ isInfoDataLoaded: false, dataLoaded: true });
      } else if (response.data.response_code === 103) {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.TicketAlreadyIssued,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
        this.setState({ isInfoDataLoaded: false, dataLoaded: true });
      } else {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.SomeThingWentWrong,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
        this.setState({ isInfoDataLoaded: false, dataLoaded: true });
      }
      console.log("RESPONSE: ", response);
    } catch (error) {
      this.setState({ isInfoDataLoaded: false, dataLoaded: true });
      console.log("ERROR: ", error.message);
    }
  };

  onChange = (e) => {
    if (e.target.id === "appointmentNumber") {
      if (
        e.target.value !== "" &&
        e.target.value.length > 0 &&
        handler.validation.isNumber(e.target.value)
      ) {
        this.setState({
          enableSubmitBtn: true,
          appointmentNumber: e.target.value,
        });
      } else {
        this.setState({ enableSubmitBtn: false });
      }
    } else if (e.target.id === "phoneNumber") {
      if (
        (e.target.value.length === 0 && e.target.value === "") ||
        e.target.value.length <
          this.userDetailsConfig.phoneNumberField.minLength ||
        /\s/.test(e.target.value) ||
        !e.target.value.charAt(0).includes("+") ||
        !/^[0-9+]+$/.test(e.target.value)
      ) {
        $("#phoneNumber").css("border-color", "red");
        this.setState({ enableSubmitBtn: false });
      } else {
        $("#phoneNumber").css("border-color", "#dadada");
        this.setState({ enableSubmitBtn: true, phoneNumber: e.target.value });
      }
    } else if (e.target.id === "emailAddress") {
      if (
        e.target.value !== "" &&
        e.target.value.length > 0 &&
        handler.validateEmail(e.target.value)
      ) {
        this.setState({ enableSubmitBtn: true, email: e.target.value });
      } else {
        $("#emailAddress").css("border-color", "#dadada");
        this.setState({ enableSubmitBtn: false });
      }
    }
  };

  rescheduleOrCancelAppointment = async () => {
    swal(
      this.state.lang.ModifyOrCancelAptMsg,

      {
        icon: "warning",
        buttons: {
          reschedule: {
            // text: this.state.lang.Reschedule,
            text: this.state.lang.Close,
            value: "reschedule",
          },
          cancelAppointment: {
            text: this.state.lang.CancelAppointment,
            value: "cancelAppointment",
            closeModal: false,
          },
        },
      }
    ).then(async (value) => {
      switch (value) {
        case "cancelAppointment":
          try {
            let response = await this.dataService.cancelAppointment(
              this.state.response.appointment_number,
              this.state.response.category_id,
              this.state.response.branch_id,
              this.state.response.user_id
            );
            swal.close();

            if (
              response.data.error !== undefined &&
              response.data.error === true
            ) {
              handler.showErrMsg(
                this.state.lang.Error,
                this.state.lang.ServerNotResponding,
                this.state.lang.Ok,
                this.state.redirectUrl
              );
            } else {
              if (response.data.response.resp_status === 1) {
                handler.showSuccessMessage(
                  this.state.lang.AppointmentCancelledSuccessfully,
                  this.state.lang.Ok,
                  this.state.redirectUrl
                );
                // handler.redirect(this.state.redirectUrl);
              } else if (response.data.response.resp_status === 6) {
                handler.showErrMsg(
                  this.state.lang.Error,
                  this.state.lang.AppointmentAlreadyCanceled,
                  this.state.lang.Ok,
                  this.state.redirectUrl
                );
              } else if (response.data.response.resp_status === -5) {
                handler.showErrMsg(
                  this.state.lang.Error,
                  this.state.lang.AppointmentInfoNotValidToCancel,
                  this.state.lang.Ok,
                  this.state.redirectUrl
                );
              } else if (response.data.response.resp_status === 2) {
                handler.showErrMsg(
                  this.state.lang.Error,
                  this.state.lang.CantCancelApptTcktIssued,
                  this.state.lang.Ok,
                  this.state.redirectUrl
                );
              } else if (response.data.response.resp_status === 7) {
                handler.showErrMsg(
                  this.state.lang.Error,
                  this.state.lang.AppointmentExpired,
                  this.state.lang.Ok,
                  this.state.redirectUrl
                );
              } else if (response.data.response.resp_status === -2) {
                handler.showErrMsg(
                  this.state.lang.Error,
                  this.state.lang.AlreadyServed,
                  this.state.lang.Ok,
                  this.state.redirectUrl
                );
              } else if (response.data.response.resp_status === -3) {
                handler.showErrMsg(
                  this.state.lang.Error,
                  this.state.lang.ApptCanceledAutomatically,
                  this.state.lang.Ok
                );
              } else {
                handler.showErrMsg(
                  this.state.lang.Error,
                  this.state.lang.SomeThingWentWrong,
                  this.state.lang.Ok,
                  this.state.redirectUrl
                );
              }
            }
          } catch (error) {
            if (error.message.includes("timeout")) {
              handler.showErrMsg(
                this.state.lang.Error,
                this.state.lang.ServerNotResponding,
                this.state.lang.Ok,
                this.state.redirectUrl
              );
            } else {
              handler.showErrMsg(
                this.state.lang.Error,
                this.state.lang.SomeThingWentWrong,
                this.state.lang.Ok,
                this.state.redirectUrl
              );
            }
          }
          break;

        case "reschedule":
          break;

        default:
      }
    });
  };

  render() {
    if (this.state.dataLoaded) {
      return (
        <div className="container">
          <div className="sl__modal">
            <ModalHead heading={this.state.lang.ModifyAppointment} />

            {this.state.isInfoDataLoaded === false ? (
              <div className="sl__modal-inner">
                <div className="sl__modal--content">
                  <div className="sl__modal--row">
                    <div className="sl__modal_form-col">
                      <label
                        className="sl__modal_form--label cancelAppointmentFieldslbl"
                        style={{ color: this.UI.labelColor }}
                      >
                        {this.state.lang.AppointmentNumber}
                      </label>
                      <input
                        type="text"
                        name="appointmentNumber"
                        maxLength={5}
                        onChange={this.onChange}
                        placeholder={this.state.lang.AppointmentNumber}
                        id="appointmentNumber"
                        className="sl__modal_form--input  cancelAppointmentFields"
                      />
                    </div>
                  </div>
                  <div className="sl__modal--row">
                    <div className="sl__modal_form-col">
                      <label
                        className="sl__modal_form--label cancelAppointmentFieldslbl"
                        style={{ color: this.UI.labelColor }}
                      >
                        {this.state.lang.EmailAddressPlaceHolder}
                      </label>
                      <input
                        type="text"
                        name="email"
                        onChange={this.onChange}
                        placeholder={this.state.lang.EmailAddressPlaceHolder}
                        id="emailAddress"
                        className="sl__modal_form--input  cancelAppointmentFields"
                      />
                    </div>
                  </div>

                  <div className="sl__modal--row">
                    <div className="sl__modal_form-col">
                      <label
                        className="sl__modal_form--label cancelAppointmentFieldslbl"
                        style={{ color: this.UI.labelColor }}
                      >
                        {this.state.lang.PhoneNumberPlaceholder}
                      </label>
                      <input
                        type="text"
                        name="phoneNumber"
                        onChange={this.onChange}
                        placeholder={this.state.lang.PhoneNumberPlaceholder}
                        maxLength={
                          this.userDetailsConfig.phoneNumberField.maxLength
                        }
                        id="phoneNumber"
                        className="sl__modal_form--input  cancelAppointmentFields"
                      />
                    </div>
                  </div>

                  {this.state.enableSubmitBtn ? (
                    <PrimaryButton
                      onClick={() =>
                        this.getAppointmentInfo(this.state.appointmentNumber)
                      }
                      bgColor={this.UI.btnColor}
                    >
                      {this.state.dataLoaded === false ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ) : null}{" "}
                      &nbsp;
                      {this.state.lang.Submit}
                    </PrimaryButton>
                  ) : null}
                </div>
              </div>
            ) : null}

            {this.state.isInfoDataLoaded ? (
              <div className="sl__modal-inner confirmed">
                <div className="sl__modal--content">
                  <h2 style={{ color: this.UI.labelColor }}>
                    {this.state.lang.AppointmentInfo}
                  </h2>

                  <div className="booking-final-container">
                    <div className="booking-summary-confirmation">
                      {this.state.response !== null ? (
                        <>
                          <BookingSummary
                            color={this.UI.labelColor}
                            label={this.state.lang.SeeYouOn}
                            text={`${this.state.response.appointment_date}  ${this.state.response.start_time_12Hr}`}
                          />

                          <BookingSummary
                            color={this.UI.labelColor}
                            label={this.state.lang.AtThe}
                            text={this.state.response.branch_name}
                          />

                          <BookingSummary
                            color={this.UI.labelColor}
                            label={this.state.lang.BookingRef}
                            text={this.state.response.appointment_number}
                            textSize={"25px"}
                          />
                        </>
                      ) : null}
                    </div>
                  </div>

                  <DangerButton
                    text={this.state.lang.ModifyOrCancelApt}
                    onClick={this.rescheduleOrCancelAppointment}
                    color={this.UI.cancelBtnColor}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      );
    } else {
      return (
        <div className="container">
          <div className="sl__modal">
            <ModalHead heading={this.state.lang.ModifyAppointment} />

            <div className="sl__modal-inner">
              <div className="sl__modal--content">
                <div className="sl__modal--row">
                  <Loader />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default ModifyAppointment;
